import Select from "react-select";
import styled from "styled-components";
import { COLOR } from '../../../helpers/theme';
import Spinner from '../../../components/Spinner';
import React, { useEffect, useState } from "react";
import Card from "../../../components/layouts/Card";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../redux/rootReducers';
import Button from '../../../components/forms/ButtonEx';
import { Inventory } from "../../../interfaces/Inventory";
import { OptionsBoolean } from "../../../interfaces/Options";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageWrapper from "../../../components/layouts/PageWrapper";
import { BootstrapGrid } from "../../../components/layouts/BootstrapGrid";
import { fieldErrorMessage, fieldHasErrors } from "../../../helpers/errorHandler";
import { InputWrapper, SelectStyle } from "../../../components/forms/FormComponents";
import { createInventoryAsync, resetState, selectInventoryAsync, setError, updateInventoryAsync } from "../../../redux/reducers/inventories/inventories.actions";

const InventoriesManagePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const errors = useSelector((state: RootState) => state.inventory.error);
  const isLoading = useSelector((state: RootState) => state.inventory.isLoading);
  const createdInventory = useSelector((state: RootState) => state.inventory.createdInventory);
  const selectedInventory = useSelector((state: RootState) => state.inventory.selectedInventory);
  const [optionBorrowable, setOptionBorrowable] = useState<{label: string; value: boolean} | null>(OptionsBoolean[0]);

  const [formTitle, setFormTitle] = useState<string>("Tambah");
  const [inventory, setInventory] = useState<Inventory>({
    item_name: '',
    item_quantity: 0,
    item_borrowable: true,
    item_featured_image: '',
    item_description: '',
    item_icon: ''
  });

  const populateData = () => {
    const paths = location.pathname.split("/");
    if (paths[3] !== 'create') {
      const inventoryId = parseInt(paths[3]);
      if (inventoryId && !isNaN(inventoryId)) {
        dispatch(selectInventoryAsync.request({ id: inventoryId }));
        setFormTitle('Ubah');
      } else {
        navigate(`/building-management/inventories/create`);
      }
    }
  }

  useEffect(() => {
    dispatch(resetState());
  }, [])

  useEffect(() => {
    populateData();
  }, [location.pathname]);


  useEffect(() => {
    if (selectedInventory) {
      setInventory(selectedInventory);
    } else {
      setInventory({
        item_name: '',
        item_quantity: 0,
        item_borrowable: true,
        item_featured_image: '',
        item_description: '',
        item_icon: ''
      });
    }
  }, [selectedInventory]);

  const whichForm = () => {
    const paths = location.pathname.split("/");
    const inventoryId = paths[3];
    if (selectedInventory && inventoryId && !isNaN(parseInt(inventoryId))) {
      return 'existing_data';
    } else if (inventoryId === 'create') {
      return 'new_data';
    } else {
      return 'unknown';
    }
  }

  const refreshPage = () => {
    if (whichForm() === 'existing_data') {
      populateData();   
    }
  }
 
  const clearError = (fieldName: string) => {
    if (errors) {
      dispatch(setError({
        ...errors,
        errors: {
          ...errors.errors,
          [`${fieldName}`]: []
        }
      }));
    }
  }

  const onChangeBorrowable = (e: any) => {
    clearError('item_borrowable');
    setOptionBorrowable(e);
  };

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('item_name');
    setInventory({
      ...inventory,
      item_name: e.target.value
    });
  };

  const onChangeQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('item_quantity');
    setInventory({
      ...inventory,
      item_quantity: parseInt(e.target.value)
    });
  };

  const onChangeFeaturedImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('item_featured_image');
    setInventory({
      ...inventory,
      item_featured_image: e.target.value
    });
  };

  const onChangeItemDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('item_description');
    setInventory({
      ...inventory,
      item_description: e.target.value
    });
  };

  const onChangeIcon = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearError('item_icon');
    setInventory({
      ...inventory,
      item_icon: e.target.value
    });
  };

  const actionCreate = () => {
    const paths = location.pathname.split("/");
    const inventoryId = paths[3];
    if (selectedInventory && inventoryId && !isNaN(parseInt(inventoryId))) {
      dispatch(updateInventoryAsync.request(inventory));
    } else if (inventoryId === 'create') {
      dispatch(createInventoryAsync.request(inventory));
    }
  }

  const renderFormSuccess = () => {
    const labelFinished = whichForm() === 'new_data' ? 'ditambahkan' : 'diubah';
    return (
      <React.Fragment>
        <div className="formSuccess">
          <h3>Inventaris <b>{ createdInventory?.item_name }</b> berhasil { labelFinished }!</h3>
        </div>
        <div className="formSubmit">
          <Link to='/building-management/inventories'>
            <Button caption="Kembali ke Daftar Inventaris" />
          </Link>
          <p>atau <Link to={`/building-management/inventories/${createdInventory?.id}`} onClick={refreshPage} className="formSubmit--update">ubah data barang</Link></p>
        </div>
      </React.Fragment>
    );
  }

  const renderFormLoading = () => {
    return (
      <React.Fragment>
        <div className="formLoading">
          <Spinner size="small" />
          <div className="formLoading--caption">Memuat Data...</div>
        </div>
      </React.Fragment>
    )
  }

  const renderNotFound = () => {
    return (
      <React.Fragment>
        <div className="formSuccess">
          <h3>Data yang Anda cari tidak dapat ditemukan. Data mungkin saja dihapus atau dipindahkan. Apakah Anda yakin alamat yang Anda akses sudah benar?</h3>
        </div>
        <div className="formSubmit">
          <Link to='/building-management/inventories'>
            <Button caption="Kembali ke Daftar Inventaris" />
          </Link>
          <p>atau <Link to={`/building-management/inventories/create`} onClick={refreshPage} className="formSubmit--update">tambahkan data baru</Link></p>
        </div>
      </React.Fragment>
    );
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="form-group">
          <InputWrapper hasErrors={fieldHasErrors('item_name', errors)}>
            <div className="input--field">
              <label>Nama Barang</label>
              <input
                type="text"
                disabled={isLoading}
                value={inventory.item_name}
                onChange={onChangeName}
                placeholder="Masukkan nama pengguna disini"
              />
            </div>
            <div className="input--errors">
              { fieldErrorMessage('item_name', errors) }
            </div>
          </InputWrapper>
        </div>
        <div className="form-group">
          <InputWrapper hasErrors={fieldHasErrors('item_borrowable', errors)}>  
            <div className="input--field select">
              <label>Izinkan Peminjaman Barang</label>
              <Select
                isDisabled={isLoading}
                styles={SelectStyle}
                options={OptionsBoolean}
                onChange={onChangeBorrowable}
                value={optionBorrowable}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
            <div className="input--errors">
              { fieldErrorMessage('item_borrowable', errors) }
            </div>
          </InputWrapper>
        </div>
        <div className="form-group">
          <InputWrapper hasErrors={fieldHasErrors('item_quantity', errors)}>
            <div className="input--field">
              <label>Jumlah</label>
              <input
                type="number"
                disabled={isLoading}
                value={inventory.item_quantity}
                onChange={onChangeQuantity}
                placeholder="Masukkan jumlah inventaris"
              />
            </div>
            <div className="input--errors">
              { fieldErrorMessage('item_quantity', errors) }
            </div>
          </InputWrapper>
        </div>
        <div className="form-group">
          <InputWrapper hasErrors={fieldHasErrors('item_description', errors)}>
            <div className="input--field">
              <label>Spesifikasi Barang</label>
              <input
                type="text"
                disabled={isLoading}
                value={inventory.item_description}
                onChange={onChangeItemDescription}
                placeholder="Masukkan spesifikasi alat"
              />
            </div>
            <div className="input--errors">
              { fieldErrorMessage('item_description', errors) }
            </div>
          </InputWrapper>
        </div>
        <div className="form-group">
          <InputWrapper hasErrors={fieldHasErrors('item_icon', errors)}>
            <div className="input--field">
              <label>Ikon</label>
              <input
                type="text"
                disabled={isLoading}
                value={inventory.item_icon}
                onChange={onChangeIcon}
                placeholder="Pilih ikon alat"
              />
            </div>
            <div className="input--errors">
              { fieldErrorMessage('item_icon', errors) }
            </div>
          </InputWrapper>
        </div>
        <div className="form-group">
          <InputWrapper hasErrors={fieldHasErrors('item_featured_image', errors)}>
            <div className="input--field">
              <label>Gambar Barang</label>
              <input
                type="text"
                disabled={isLoading}
                value={inventory.item_featured_image}
                onChange={onChangeFeaturedImage}
                placeholder="Unggah gambar barang"
              />
            </div>
            <div className="input--errors">
              { fieldErrorMessage('item_featured_image', errors) }
            </div>
          </InputWrapper>
        </div>

        <div className="formSubmit">
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            onClick={actionCreate}
            caption={`${formTitle} Inventaris`}
          />
        </div>
      </React.Fragment>
    );
  }

  return (
    <PageWrapper>
      <InventoriesManagePageWrapper>
        <BootstrapGrid>
          <div className="row">
            <div className="col-lg-4">
              <Card>
                <div className="card--title">
                  <h2 className="card--title-title">{formTitle} Inventaris</h2>
                </div>
                <div className="card--body">
                  { (() => {
                    if (isLoading) {
                      return renderFormLoading();
                    } else if (!selectedInventory && errors) {
                      return renderNotFound();
                    } else if (createdInventory) {
                      return renderFormSuccess();
                    } else{
                      return renderForm();
                    }
                  })() }
                </div>
              </Card>
              
            </div>
          </div>
        </BootstrapGrid>
      </InventoriesManagePageWrapper>
    </PageWrapper>
  );
}

const InventoriesManagePageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;

  & .formTitle {
    margin-bottom: 10px;
  }

  & .formLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    & > .formLoading--caption {
      font-size: 14px;
      margin-top: -3px;
      margin-left: 10px;
    }
  }

  & .formSuccess {
    & > h3 {
      font-size: 14px;
      font-weight: normal;
      text-align: center;
    }
  }
  
  & .formSubmit {
    margin-top: 30px;
    text-align: center;

    & > p {
      margin-top: 5px;
      & > .formSubmit--update {
        cursor: pointer;
        color: ${COLOR.SECONDARY}
      }
    }
  }
`;

export default InventoriesManagePage;